import { Routes } from '@angular/router';
import { PageKey } from '../../../shared/services/page/models/page.key';
import { canActivate } from '../../../shared/guard/guard';
import { HeaderEnum, PermissionEnum } from '../../../../environments/shared-environment/permission';

export const informsRoutes: Routes = [{
  path: 'informs',
  canActivateChild: [() => canActivate(HeaderEnum.INFORMS, PermissionEnum.VIEW)],
  loadComponent: () => import('./informs.component').then(m => m.InformsComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./list/list.component').then(m => m.ListInformsComponent),
      data: {
        title: 'Visualizar Informativos',
        key: PageKey.INFORM,
        fullscreen: true
      },
    },
    {
      path: ':id/details',
      loadComponent: () => import('./details/details.component').then(m => m.InformDetailsComponent),
      data: {
        title: 'Detalhes do Informativo',
        key: PageKey.INFORM
      },
    },
    {
      path: ':id/update',
      loadComponent: () => import('./create/create.component').then(m => m.CreateInformComponent),
      data: {
        title: 'Atualizar Informativo',
        key: PageKey.INFORM
      },
    },
    {
      path: 'create',
      loadComponent: () => import('./create/create.component').then(m => m.CreateInformComponent),
      data: {
        title: 'Criar Informativo',
        key: PageKey.INFORM
      },
    },
  ]
}];
